import { useAppStore } from '../store/useAppStore';
import { formatTon } from '../lib/format';

// Горизонтальная лента ставок других игроков (новые слева).
export function LiveTicker() {
  const feed = useAppStore((s) => s.liveFeed);
  if (feed.length === 0) return null;

  return (
    <div className="ticker">
      <span className="ticker-label">LIVE</span>
      <div className="ticker-items">
        {feed.map((it) => (
          <div key={it.id} className={`ticker-item ${it.win ? 'win' : 'lose'}`}>
            <span className="ticker-name">{it.name}</span>
            <span className="ticker-game">{it.game === 'dice' ? 'Dice' : 'Рулетка'}</span>
            {it.win ? (
              <span className="ticker-payout">
                ×{it.multiplier.toFixed(2)} +{formatTon(it.payout)}
              </span>
            ) : (
              <span className="ticker-lose">−{formatTon(it.stake)}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
